import { render, staticRenderFns } from "./tabInternalProjectSummaryReport.vue?vue&type=template&id=782da5ca&"
import script from "./tabInternalProjectSummaryReport.vue?vue&type=script&lang=ts&"
export * from "./tabInternalProjectSummaryReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports